export default __webpack_public_path__ + "img/3eb5fb85555c5f7452267d55e75ae546.svg";